var DateUtil = {
  formatDateToStr: function (dd) {
    return dd.getFullYear() + '-' + (dd.getMonth() + 1 > 10 ? dd.getMonth() + 1 : '0' + (dd.getMonth() + 1)) + '-' + (dd.getDate() > 10 ? dd.getDate() : '0' + dd.getDate()) + ' ' + dd.getHours() + ':' + dd.getMinutes() + ':' + dd.getSeconds();
  },
  formatDateToStrFixed: function (dd) {
    const year = dd.getFullYear();
    const month = (dd.getMonth() + 1).toString().padStart(2, '0');
    const date = dd.getDate().toString().padStart(2, '0');
    const hours = dd.getHours().toString().padStart(2, '0');
    const minutes = dd.getMinutes().toString().padStart(2, '0');
    const seconds = dd.getSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`;
  },
  transfromStrToMoment: function (time) {
    return $moment(new Date(time));
  },
  getDateStr : function() {
    const now = new Date();
    const year = now.getFullYear(); // 获取当前年份，返回 4 位数字
    const month = now.getMonth() + 1; // 获取当前月份，返回 0 ~ 11，需要加 1
    const date = now.getDate(); // 获取当前日期，返回 1 ~ 31
    const hour = now.getHours(); // 获取当前小时数，返回 0 ~ 23
    const minute = now.getMinutes(); // 获取当前分钟数，返回 0 ~ 59
    const second = now.getSeconds(); // 获取当前秒数，返回 0 ~ 59
    return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
  }
}
export {DateUtil};



// WEBPACK FOOTER //
// ./src/components/utils/date_util.js